module.exports = __webpack_public_path__ + "static/media/Noelle.c8a5da49.png";